var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "description" } }, [
    _c("div", { staticClass: "material-icons time-icon" }, [_vm._v("notes")]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("span", { staticClass: "time-label" }, [
        _vm._v(_vm._s(_vm.$t("calendar.description"))),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "time-sub-label" }, [
        _vm._v(_vm._s(_vm.$t("calendar.descriptionDesc")) + "\n        "),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.description,
            expression: "description",
          },
        ],
        staticClass: "description-input",
        domProps: { value: _vm.description },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.description = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }